import { grayDark, baseLighter } from '../styles/colors';
import {
  TextFieldBackgroundState,
  TextFieldBorderState,
  TextFieldInputState,
} from './types';

// Wrapper classes

export const BACKGROUND_COLOR: { [key in TextFieldBackgroundState]: string } = {
  light: 'bg-white',
  'light-disabled': 'bg-gray-main',
  dark: 'bg-base-light-dark-mode',
  'dark-disabled': 'bg-gray-dark-70',
};

export const BORDER_COLOR: { [key in TextFieldBorderState]: string } = {
  light: 'border-gray-dark',
  'light-focused': 'border-primary-main',
  dark: 'border-transparent',
  'dark-focused': 'border-primary-lighter',
  error: 'border-red-main',
  disabled: 'border-transparent',
};

export const HINT_COLOR: { [key in TextFieldBackgroundState]: string } = {
  light: grayDark,
  'light-disabled': grayDark,
  dark: baseLighter,
  'dark-disabled': grayDark,
};

export const INPUT_TEXT_COLOR: { [key in TextFieldInputState]: string } = {
  light: 'text-base-main caret-primary-main',
  'light-error': 'text-base-main caret-red-main',
  'light-disabled': 'text-gray-dark',
  dark: 'text-white caret-primary-lighter',
  'dark-error': 'text-white caret-red-main',
  'dark-disabled': 'text-gray-dark',
};

export const BASE_INPUT =
  'w-full z-1 border-0 resize-none focus:outline-none min-h-40 bg-transparent';
